import React, { useLayoutEffect, useState, useEffect, useRef, useContext, useMemo } from 'react';

import { ProgressBar } from 'primereact/progressbar';
import { Skeleton } from 'primereact/skeleton';
import {calcPercent} from '../utils/utils'

import classNames from 'classnames';
import AppContext from '../hooks/AppContext'

const ZonaDetalhe = (props) => {    
    
    const {locaisVotacao, setZonaESelecionadaId, setLocalVSelecionadoId, setOcultaLidas, setOcultaNLidas} = useContext(AppContext);

    const buttonCollapse = useRef()
    const [detailIsVisible, setDetailIsVisible] = useState(false)

    const titleBlock = () =>{        
        let Title = "ZE: "+ props?.zona
        if(props?.localVotacao){
            Title+=" - " + props?.localVotacao
        }
        if(props?.localidades){
            Title+=" - " + props?.localidades?.map(l => {
                if(l?.nmUe){
                    return l?.nmUe;
                }
                if(l && typeof l === 'string'){
                    return l
                }
                return "nomeLocalidade"
            }).join(", ")
        }
        return Title
    }    

    const detalheZona = () =>{
        if(!detailIsVisible){
            setZonaESelecionadaId(props?.zona);                       
            buttonCollapse.current.className = "bloco-subtitle pi pi-arrow-circle-up"
        }else{
            setZonaESelecionadaId();
            setLocalVSelecionadoId();
            buttonCollapse.current.className = "bloco-subtitle pi pi-arrow-circle-down";
        }
        setDetailIsVisible(current => !current)        
    }
    
    const percentual = useMemo(()=> {
        return calcPercent(props?.secoesLidas?.length, props?.total) || 0
    },[props?.secoesLidas?.length, props?.total])    
    
    const emptySearch = useMemo(() => {
        return props?.search?.length>0 && props?.search[0]!=''
    },[props?.search])
    
    const locaisTmp = useMemo(()=>{
        return locaisVotacao.filter(locv => { return (locv?.nrZona==props?.zona)})
    },[locaisVotacao])    

    const renderSecoes = (arraySecoes, classNameSecoes) =>{
        return (
            arraySecoes?.map(s => {
                const includes = props?.search?.includes(String(s))
                const wrappesecao = classNames("custom-chip "+classNameSecoes+" chip-secoes",{
                    "custom-chip-highlight": includes,
                    "custom-chip-opaque": emptySearch && !includes
                })

                let localVEncontrado = locaisTmp.find(locv => locv?.secoes?.includes(Number(s)))
                return(
                    <div key={s}  className={wrappesecao}>{s}
                        {localVEncontrado &&
                            <span className="chip-secoes-tooltip">{localVEncontrado?.nmLocal}</span>
                        }
                    </div>
                )
            }) 
        )
    }

    const wrappesecoes = classNames("bloco-dados bg-gray-200 flex-wrap secoes",{
        "secoes-resumo": !props?.detalhes,
        "secoes-resumo-skeleton" : !props?.detalhes && props?.skeleton
    })

    const wrapperbarraprogresso = classNames("barraProgresso",{
        "barraAnimada": (percentual!=0 && percentual<100),
        "barraVazia": percentual==0,
        "barraCheia": percentual>=100
    })

    const wrapperBlocoTitle = classNames("bloco-title font-bold",{       
        "bloco-secao-resumo-title": !props.localidades        
    })

    const wrapperSecoesLidasTitle = classNames("bloco-title w-full flex flex-row justify-content-between align-items-baseline pb-2 mb-2 border-bottom-GrayLine",{       
        "border-bottom-GreenLine" : percentual>=100
    })

    const wrapperSecoesNaoLidasTitle = classNames("bloco-title w-full flex flex-row justify-content-between align-items-baseline",{
        "mb-2 border-bottom-GrayLine": (!props?.ocultaNLidas && props?.secoesNaoLidas?.length>0 || detailIsVisible)               
    })

    if(props?.skeleton){
        return (<Skeleton className={wrappesecoes} ></Skeleton> )
    }
    return(                                             
        <div className={wrappesecoes}>
            
            {props.progresso &&
                <ProgressBar className={wrapperbarraprogresso} 
                    value={percentual}
                    displayValueTemplate={(value) => <React.Fragment></React.Fragment>}>
                </ProgressBar>
            }
            
            <div className="flex flex-row justify-content-between align-items-baseline">
                <div className={wrapperBlocoTitle}>{titleBlock()}</div>
                {props.detalhes && 
                    <i ref={buttonCollapse} className="bloco-subtitle pi pi-arrow-circle-down" style={{float: 'right'}} onClick={detalheZona}></i>
                }
            </div>

            {props.detalhes ?                    
                    <div>
                        <div className="mt-2">                            
                            <div className={wrapperSecoesLidasTitle}>                                     
                                <div>Seções lidas: {props?.secoesLidas?.length.toLocaleString()}</div>                                    
                                <div>Total: {props?.total.toLocaleString()}</div>
                            </div>
                            {(!props?.ocultaLidas || detailIsVisible)  &&
                                <div className="flex flex-wrap gap-2">
                                    {renderSecoes(props?.secoesLidas, "custom-Lidas-chip")}
                                </div>                           
                            }
                        </div>                                     
                       
                        {percentual<100 &&                       
                            <div className="mt-2">                        
                                <div className={wrapperSecoesNaoLidasTitle}>                                    
                                    <div>Seções não lidas: {props?.secoesNaoLidas?.length.toLocaleString()}</div>                               
                                </div>
                                {(!props?.ocultaNLidas || detailIsVisible)  &&                  
                                    <div className="flex flex-wrap gap-2">
                                        {renderSecoes(props?.secoesNaoLidas, "custom-NLidas-chip")}              
                                    </div>
                                }
                            </div>
                        }                        

                    </div>

                :
                    <div className="bloco-secao-resumo">Lidas: {props?.secoesLidas?.length.toLocaleString()} de {props?.total.toLocaleString()}</div>
            }
        </div>          
    )
}
export default ZonaDetalhe;    
